import DemoBanner from './DemoBanner';

export default DemoBanner;
